import { buildContainer } from '@monofe/util';
import { bindContainer, IContainer, injectContainer } from '../interface/container';

const CONTAINER_KEY = 'worker';

export default function container(parentContainer?: IContainer): IContainer {
    const container = injectContainer(CONTAINER_KEY);

    if (container) {
        return container;
    }

    const newContainer = buildContainer(parentContainer ? [parentContainer] : []);
    bindContainer(newContainer, CONTAINER_KEY);

    return newContainer;
}
